export const DATETIME_BACKEND_FORMAT = 'YYYY-MM-DDT00:00:00';

export const DATA_KIND = {
  dashboard: "dashboard",
  onboarding: "onboarding",
  topMatches: "topMatches",  // for the future logic with un-logged users
};
